export default "/images/coffee.svg?63ddee6e256674317cbba9c230b43a45";